import { render, staticRenderFns } from "./MyFlag.vue?vue&type=template&id=459a5718&lang=html&"
import script from "./MyFlag.vue?vue&type=script&lang=js&"
export * from "./MyFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MyFlag.vue"
export default component.exports